module.exports = __webpack_public_path__ + "img/bg_1024.07ccde23.png";